/**
 * @fileoverview POST handler for the "/engagement/predictions" endpoint
 */
import type { PredictionUpdatePayload } from "@predictions/PredictionDigest/types";
import type { LimitError, PredictionPayload, WarnMessage } from "@predictions/types";

import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementPredictionsCacheKeys } from "./constants";

export const postEngagementPredictions = reactQueryMutationAdapter(
  engagementPredictionsCacheKeys,
  (props: PredictionUpdatePayload): Promise<PredictionPayload | WarnMessage | LimitError> => {
    return fetch("/engagement/predictions", "POST", props);
  }
);
